import { NgModule } from '@angular/core';
import { LibConsentDeclinedIconComponent } from './lib-consent-declined-icon.component';

@NgModule({
  declarations: [LibConsentDeclinedIconComponent],
  imports: [],
  exports: [LibConsentDeclinedIconComponent],
})
export class LibConsentDeclinedIconModule {}
